<template>
  <div class="field p-fluid">
    <label for="completion_time">New Width (m)</label>
    <NumberInput 
        inputId="rw-new-width" 
        ref="new-width-input" 
        v-model="form.new_width" 
        class="w-full" 
        :useGrouping="false"
        :maxFractionDigits="2"
    />
  </div>
</template>

<script>
import { useRecordTarpRepairsStore } from '@/stores/RecordTarpRepairs';

import NumberInput from '@/components/forms/NumberInput.vue';

import Message from 'primevue/message';

export default {
  name: "NewWidth",
  components: {
    Message,
    NumberInput,
  },
  created() {
      this.store = useRecordTarpRepairsStore();
  },
  computed: {
    form() {
        return this.store.tarp_repair;
    },
  }
}

</script>